import { CLICK, SCROLL } from '../dictionary/scrollevents';
export const scrollOnClick = (id, eventType, setEventType) => {
  if (eventType == SCROLL) return;
  const elem = document.getElementById(id);
  if (!elem) return;
  const top = elem.getBoundingClientRect().top + window.scrollY - 180;
  window.scroll({
    top,
    behavior: 'smooth',
  });
  setTimeout(() => setEventType(SCROLL), 1000);
};

export const selectOnScroll = (id, eventType, setCategoryId) => {
  const dropdownPopupElem = document.querySelector('.dropdown-popup');
  if (dropdownPopupElem) return;
  if (eventType == CLICK) return;
  const container = document.getElementById(id);
  if (!container) return;
  const children = Object.values(container.children);
  let min_vertical_distance = 1000000000; //initial offset

  children.forEach((elem, index) => {
    const { y, height } = elem.getBoundingClientRect();
    if (height + y > 200 && height + y <= min_vertical_distance) {
      min_vertical_distance = height + y;
      setCategoryId(index);
    }
  });
};

export const setHorizontalScrollActive = (parentId, childId) => {
  const elem = document.getElementById(childId);
  const container = document.getElementById(parentId);
  if (elem)
    container.scrollTo({
      left: elem.offsetLeft,
      behavior: 'smooth',
    });
};

export const setVerticalScrollActive = (id) => {
  const elem = document.getElementById(id);
  if (elem) elem.scrollIntoView({ block: 'center' });
};
